import SetPostAsSeenError from './SetPostAsSeenError';
class PostAlreadySeen extends SetPostAsSeenError {
    postId;
    constructor(postId, options) {
        super('Post is already seen', options);
        this.postId = postId;
    }
}
export default PostAlreadySeen;
